import { useSyncExternalStore } from 'react';
import appearanceStore from './appearanceStore';

export default function useAppearance(store = appearanceStore) {
    const { enabled, choice, scheme } = useSyncExternalStore(store.subscribe, store.getSnapshot);

    return {
        enabled,
        choice,
        scheme,
        setChoice: store.setChoice,
    };
}
